export default {
    TRADERA: 'https://www.tradera.com/'
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/constants/hosts.js